import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';
import { ArrowheadRightSmall, LinkSmall } from '@blueprint/icons';

const BaseArrow = ({ className }: { className?: string }) => (
    <ArrowheadRightSmall className={className} />
);

const Link = ({ className }: { className?: string }) => (
    <LinkSmall className={className} />
);

export const Arrow = styled(BaseArrow)(
    ({ theme: { colors } }) => css`
        color: ${colors['text-body']};
        margin-left: auto;
    `
);

export const LinkIcon = styled(Link)(
    ({ theme: { colors } }) => css`
        color: ${colors['icon-dark']};
    `
);

const baseStyles = css`
    display: flex;
    position: relative;
    width: 100%;
    align-items: center;
    background: none;
    cursor: pointer;
`;

export const ShareButton = styled('button')(
    ({ theme: { colors, spacing, focusRing, fontSizes } }) => css`
        ${baseStyles}
        color: ${colors['text-title']};
        padding: ${spacing['16px']};
        border: none;
        font-size: ${fontSizes['2']};
        span {
            position: absolute;
            left: ${spacing['48px']};
        }
        &:focus {
            outline: none;
            box-shadow: ${focusRing};
        }
    `
);

export const ShareLinkButton = styled('a')(
    ({ theme: { colors, focusRing, spacing } }) => css`
        ${baseStyles}
        color: ${colors['text-title']};
        padding: ${spacing['16px']};
        span {
            position: absolute;
            left: ${spacing['48px']};
        }
        &:focus {
            outline: none;
            box-shadow: ${focusRing};
        }
    `
);

export const ShareList = styled('ul')(
    ({ theme: { mq, spacing, colors } }) => css`
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
            padding: 0;
            border-top: 1px solid ${colors['graphic-divider-light']};

            &:last-child {
                border-bottom: 1px solid ${colors['graphic-divider-light']};
            }
        }
        ${mq.medium} {
            margin: 0 -${spacing['8px']};
            display: flex;
            flex-wrap: wrap;
            li {
                width: calc(50% - ${spacing['16px']});
                margin: 0 ${spacing['8px']} ${spacing['8px']} ${spacing['8px']};
                border: 1px solid ${colors['graphic-divider-light']};
            }
        }
    `
);

export const ShareListItem = styled('li')();
export const ShareListItemMobileOnly = styled('li')(
    ({ theme: { mq } }) => `
        ${mq.medium} {
            display: none;
        }
`
);

export const ShareHeading = styled(Heading2)(
    ({ theme: { spacing } }) => css`
        text-align: center;
        margin: ${spacing['8px']} ${spacing['16px']} ${spacing['32px']};
    `
);
